import React, { useState } from "react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const API_URL = "https://qmstest.motion.ac.in/apiseq/api/v1";
const UPLOAD_ENDPOINT = "common/fileupload";

const userToken =
  typeof window !== "undefined"
    ? JSON.parse(localStorage.getItem("user") || "{}")?.accessToken
    : null;

const MyEditor = ({ handleChange, data, onInit, ...rest }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return loader.file.then((file) => {
          const body = new FormData();
          body.append("file", file);

          return fetch(`${API_URL}/${UPLOAD_ENDPOINT}`, {
            method: "POST",
            body: body,
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          })
            .then(async (res) => {
              
              if (!res.ok) {
                const text = await res.text();
                throw new Error(text);
              }
              
              return res.json();
              
            })
            .then((res) => ({
              default: `https://cdnqms.motion.ac.in/${res.data.key}`,
            }));
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const ckEditorConfig = {
    extraPlugins: [uploadPlugin],
    toolbar: {
      shouldNotGroupWhenFull: true,
    },
  };

  return (
    <div className={isFullScreen ? "editor-fullscreen" : "editor-normal"}>
      {/* Icon Button */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <button
          onClick={() => setIsFullScreen(!isFullScreen)}
          title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "6px",
          }}
        >
          {isFullScreen ? (
            /* Exit Fullscreen Icon */
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#333" d="M14 14h5v5h-2v-3h-3v-2zm-4 0v2H7v3H5v-5h5zm9-9v5h-2V7h-3V5h5zM5 5h5v2H7v3H5V5z"/>
            </svg>
          ) : (
            /* Fullscreen Icon */
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#333" d="M7 14H5v5h5v-2H7v-3zm0-4h2V7h3V5H5v5zm10 9h-3v2h5v-5h-2v3zm-3-14v2h3v3h2V5h-5z"/>
            </svg>
          )}
        </button>
      </div>

      <CKEditor
        editor={Editor}
        data={data}
        onInit={onInit}
        config={ckEditorConfig}
        onReady={(editor) => {
          console.log("Editor ready", editor);
        }}
        onChange={(event, editor) => {
          console.log(editor.getData());
        }}
        onBlur={(event, editor) => {
          handleChange(editor.getData());
        }}
        {...rest}
      />
    </div>
  );
};

export default MyEditor;